<template>
    <div :class="$style.wrapper">
        <div :class="$style.header">
            <span>订单号：<span :class="$style.black">{{order.order_sn}}</span></span>
            <span :class="$style.divider">|</span>
            <span>{{order.order_time}}</span>
            <span :class="$style.divider">|</span>
            <span>{{order.payname}}</span>
            <span :class="$style.divider">|</span>
            <span>收货人：{{order.consignee}}</span>
            <span :class="$style.divider">|</span>
            <span>vip卡号:{{order.single_number}}</span>
        </div>
        <div :class="$style.content">
            <div style="width: 40%">
                <div :class="$style.orderInfo"
                     :key="rec_id"
                     v-for="{rec_id, goods_name, goods_attr, goods_img,referer,order_id, goods_number, goods_price,goods_id, goods_attr_id, goods_attr_list, product_id} in order.goods_list">
                    <div style="width: 72%">
                        <img :src="host + '/' + goods_img" alt="">
                        <span style="text-align: left; word-break: break-all;">
                                       {{goods_name}}
                            <pre style="color: gray;font-size: 12px;margin: 0; line-height: 1.5">{{goods_attr}}</pre>
                        </span>
                    </div>
                    <span style="width: 15%; text-align: center">￥{{goods_price}}</span>
                    <span style="width: 10%; text-align: center">{{goods_number}}</span>
                    <div>
                        <Confirm v-if="order.status === 0&&Auth.cancelOrder===true&&order.pay_all==''"
                                 :handleConfirm="()=>deleteOrder(order.goods_list,rec_id)" :loading="btnLoading">
                            <el-button size="small" type="danger" icon="el-icon-delete">删除</el-button>
                        </Confirm>
                        &nbsp;&nbsp;
                        <Dialogsa
                            :goods_attr_list="goods_attr_list"
                            :goods_attr_id="goods_attr_id"
                            :goods_id="goods_id"
                            :rec_id="rec_id"
                            :product_id="product_id"
                            :referer="referer"
                            :goods_price="goods_price"
                            :order_id="order_id"
                            :goods_number="goods_number"
                            :getCartProducts="getCartProducts"
                            :getOrderList="getOrderList"
                        >
                            <el-button type="warning" icon="el-icon-edit" size="small"
                                       v-if="order.status === 0&&Auth.editOrderGoods==true&&order.pay_all==''">修改商品
                            </el-button>
                        </Dialogsa>
                    </div>
                </div>
            </div>
            <div :class="$style.payPrice">
                <span>{{order.goods_amount}}</span>
                <p>{{order.xiadanname}}</p>
            </div>
            <div :class="$style.status">
                <span v-if="order.status === 0">等待付款</span>
                <span v-else-if="order.status === 1">交易关闭</span>
                <span v-else-if="order.status === 2">待发货</span>
                <span v-else-if="order.status === 3">已发货</span>
                <span v-else-if="order.status === 4">交易成功</span>
                <span v-else-if="order.status === 5">已申请退货</span>
                <el-popover
                    ref="popover1"
                    placement="bottom"
                    width="150"
                    trigger="hover"
                >
                    <div>
                        <div
                            v-for="({content, time}, index) in order.track"
                            :key="index"
                            style="display: flex; align-items: flex-start; font-size: 12px; margin-bottom: 5px">
                            <span class="point"/>
                            <div style="display: flex; flex-direction: column;">
                                <span>{{content}}</span>
                                <span>{{time}}</span>
                            </div>
                        </div>
                    </div>
                </el-popover>
                <!-- <p><span v-popover:popover1 style="cursor: pointer">跟踪</span><i class="el-icon-caret-bottom"/></p> -->
            </div>
            <!--利润-->
            <!--<div :class="$style.payPrice" style="width: 7%">-->
            <!--&lt;!&ndash;<span>{{order.goods_amount}}</span>&ndash;&gt;-->
            <!--<span>{{order.jxlirun}}</span>-->
            <!--</div>-->
            <div :class="$style.action">
                <!--<el-button v-if="order.status ===0&&order.is_upload===0&&Auth.payOrder==true"-->
                           <!--@click="open(order.order_id)">-->
                <el-button v-if="order.status ===0&&order.is_upload===0&&Auth.payOrder==true"
                           @click="open(order.order_id)">支付
                </el-button>
                <el-button v-else-if="order.status ===0&&order.is_upload===1" @click="open(order.order_id)">上传凭证
                </el-button>
                <p :class="$style.wait" v-else-if="order.status===0&&order.is_upload===2">正在审核</p>
                <AddressDialog
                    v-else-if="order.status ===2&&order.is_yuyue===0"
                    :editData="addressData"
                    :type="3"
                    :time="currAppointment"
                    :order="order"
                >
                    <el-button style="background: #F56C31" @click="getAppointment(order.order_sn)">预约安装</el-button>
                    <div slot="additional">
                        <el-button
                            v-for="{time, format_time, remaining} in appointmentData"
                            :key="time"
                            :style="{
                                color: remaining <=0? '#c7ccd4': '#2795f5',
                                borderWidth: remaining <=0? 0: 1,
                                borderColor: currAppointment === time? '#2795f5': 'transparent'
                            }"
                            :disabled="remaining <=0"
                            @click="handleSelectAppointment(time)"
                        >
                            {{format_time}}
                        </el-button>
                    </div>
                </AddressDialog>
                <el-button disabled style="background: #BDBABA" v-else-if="order.status ===2&&order.is_yuyue===1">
                    已预约安装
                </el-button>
                <p v-else-if="order.status ===3||order.status ===5" :class="$style.wait">待确认</p>
                <p v-if="order.status === 0 &&Auth.editPay==true">
                    <PayStyleDialog :order="order" :update="getOrderList"><span>修改支付方式</span></PayStyleDialog>
                </p>
                <p v-if="Auth.lookOrder==true"><span
                    @click="$router.push('/OrderList/'+ order.order_sn)">订单详情</span></p>
                <!-- <Confirm v-if="order.status === 0&&in_array(orderAuth,'payOderr')=='true'" :handleConfirm="cancelOrder" :loading="btnLoading">
                    <p style="display: inline"><span>取消</span></p>
                </Confirm> -->
                <!-- <p  v-if="order.status === 0&&in_array(orderAuth,'payOderr')=='true'" style="display: inline" @click="removes(order)"><span>取消</span></p> -->
                <!--status=4交易成功和status=1交易关闭显示 删除按钮-->

                <Confirm v-if="order.status === 0" :handleConfirm="()=>deleteOrder(order.goods_list,rec_id)"
                         :loading="btnLoading">
                    <!-- <p style="display: inline"><span>删除</span></p> -->
                </Confirm>

                <p v-else-if="order.status ===0&&order.is_upload===1&&Auth.payOderr==true"><span
                    @click="checkimg(order)">查看支付凭证</span></p>
                <p v-if="order.status ===0&&order.payname=='线下付款'&&order.referer!='供应链'&&Auth.payOderr==true">
                    <span @click="confirm(order)">确认付款</span></p>
                <p v-if="Auth.print==true"><a style="text-decoration:none;color:#9ca2ad;"
                                              target="_blank"
                                              :href="'http://shop.gdeton.cn/admin/order.php?act=info&order_id='+order.order_id+'&print='+1"
                                              class="points">打印合同</a></p>
                <p class="points" v-if="order.status === 0&&Auth.addOrderGoods==true"
                   @click="addorder(order.order_id)">添加商品</p>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        host,
        cancelOrder,
        getAppointment,
        deleteOrder,
        session_id,
        getCartProducts,
        getUserInfo
    } from '../../stores/api';
    import PayStyleDialog from '../Common/PayStyleDialog.vue';
    import AddressDialog from '../Common/AddressDialog.vue';
    import Confirm from '../Common/Confirm.vue';
    import Vue from 'vue';
    import Dialogs from './Dialogs.vue';

    Vue.component('Dialogsa', Dialogs);
    Vue.component('PayStyleDialog', PayStyleDialog);
    Vue.component('AddressDialog', AddressDialog);
    Vue.component('Confirm', Confirm);
    export default {
        props: ['order', 'getOrderList'],
        data() {
            return {
                host: host,
                cancelVisible: false,
                btnLoading: false,
                addressData: null,
                appointmentData: [],
                currAppointment: '',
                orderAuth: '',
                referer:'',
                Auth:{
                    payOrder:false,
                    addOrderGoods:false,
                    editPay:false,
                    lookOrder:false,
                    print:false,
                    cancelOrder:false,
                    editOrderGoods:false,
                    lirun:false
                },
                hrefs: '',
            };
        },
        created(){
            this.getqx()
            // console.log(this.order);
        },
        methods: {
            cancelOrder() {
                this.btnLoading = true;
                cancelOrder(this.order.order_sn).then(() => {
                    this.$notify.success({
                        title: '操作成功',
                        message: '该订单已关闭',
                    });
                    this.cancelVisible = false;
                    this.order.status = 1;
                }).catch(err => {
                    this.$notify.error({
                        title: '操作失败',
                        message: err.message,
                    });
                }).then(() => {
                    this.btnLoading = false;
                });
            },
            deleteOrder(order, rec_id) {
                this.btnLoading = true;
                deleteOrder(order, rec_id).then((res) => {
                    this.$notify.success({
                        title: '操作成功',
                        message: '该订单已删除',
                    });
                    this.cancelVisible = false;
                    this.visible = false;
                    this.getOrderList();
                }).catch(err => {
                    this.$notify.error({
                        title: '操作失败',
                        message: err.message,
                    });
                }).then(() => {
                    this.btnLoading = false;
                });
            },
            getAppointment(order_sn) {
                getAppointment(order_sn).then(res => {
                    this.addressData = res.data.addres_data;
                    this.appointmentData = res.data.yuyue_data;
                    for (let i = 0, len = res.data.yuyue_data.length; i < len; i++) {
                        if (res.data.yuyue_data[i].remaining > 0) {
                            this.currAppointment = res.data.yuyue_data[i].time;
                            break;
                        }
                    }
                });
            },
            handleSelectAppointment(time) {
                if (this.currAppointment !== time) {
                    this.currAppointment = time;
                }
            },
            open(id) {
                window.open(host + '/flow.php?step=order_pay&id=' + id);
            },
            //查看凭证
            checkimg(order) {
                window.open(host + order.payimg);
            },
            //确认付款
            confirm(order) {
                this.$confirm('确认支付, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http.get('http://shop.gdeton.cn/user.php?act=order_confirmPay&session_id=' + session_id + '&order_id=' + order.order_id)
                        .then((res) => {
                            console.log(res);
                            this.$router.go('/OrderList')
                            this.$message({
                                type: 'success',
                                message: '成功支付!'
                            });
                        })
                        .catch((res) => {
                            console.log(res)
                        })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消支付',
                    })
                });
            },
            //取消订单
            removes(order) {
                this.$confirm('确认取消订单, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http.get(this.$reqUrl + 'user.php?act=cancel_order&session_id=' + session_id + '&order_id=' + order.order_id)
                        .then((res) => {
                            this.$router.go('/OrderList')
                            this.$message({
                                type: 'success',
                                message: '成功取消订单!'
                            });
                        })
                        .catch((res) => {
                            // console.log(res)
                        })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作',
                    });
                });
            },
            //添加商品
            addorder(order, goods_id) {
                localStorage.setItem('order_id', order);
                this.$router.push('/SupplyChain/AddProduct');
            },
            in_array(element, a) {
                // console.log(JSON.parse(sessionStorage.getItem('orderAuth')))
                // console.log(element)
                for (var i = 0; i < element.length; i++) {
                    if (element[i] === a) {
                        // console.log("sss")
                        return true;
                    }
                }
                return false;
            },
            //权限设置
            //
            getqx() {
                getUserInfo().then(res => {
                    // console.log(res)
                    this.orderAuth = res.data.userinfo.orderAuth.split(",");
                    // sessionStorage.setItem('orderAuth',JSON.stringify(this.orderAuth))
                    // console.log(this.orderAuth)
                    this.orderAuth.forEach((item,i)=>{
                        if(item==='payOrder'){
                            // console.log('ss')
                            this.Auth.payOrder=true
                        }
                        if(item==='addOrderGoods'){
                            this.Auth.addOrderGoods=true
                        }
                        if(item==='editPay'){
                            this.Auth.editPay=true
                        }
                        if(item==='lookOrder'){
                            this.Auth.lookOrder=true
                        }
                        if(item==='print'){
                            this.Auth.print=true
                        }
                        if(item==='cancelOrder'){
                            this.Auth.cancelOrder=true
                        }
                        if(item==='editOrderGoods'){
                            this.Auth.editOrderGoods=true
                        }
                        if(item==='lirun'){
                            this.Auth.lirun=true
                        }
                    })
                    // console.log(this.Auth);
                    // function in_array(element, a) {
                    //     // console.log(element)
                    //     for (var i = 0; i < element.length; i++) {
                    //         if (element[i] === a) {
                    //             console.log("sss")
                    //             return true;
                    //         }
                    //     }
                    //     return false;
                    // }
                    // console.log(in_array(this.orderAuth, 'payOrder'))
                })
            }
        },
    };
</script>
<style lang="less" module>
    .wrapper {
        margin-bottom: 15px;
        border: 1px solid #d8dde6;
        .header {
            padding: 0 20px;
            display: flex;
            position: relative;
            background: #f0f5fc;
            height: 43px;
            line-height: 43px;
            font-size: 14px;
            color: #9ca2ad;
            .divider {
                margin: 0 8px;
            }
            .black {
                color: #1f2329;
            }
        }
        .content {
            display: flex;
            color: #1f2329;
            .orderInfo {
                width: 100%;
                padding: 20px;
                padding-right: 0;
                display: flex;
                border-top: 1px solid #d8dde6;
                border-right: 1px solid #d8dde6;
                & > div {
                    display: flex;
                    img {
                        width: 99px;
                        height: 99px;
                        margin-right: 5px;
                        border: 1px solid #dee0e0;
                    }
                }
            }
            .payPrice {
                width: 20%;
                padding-top: 20px;
                text-align: center;
                border-top: 1px solid #d8dde6;
                border-right: 1px solid #d8dde6;
                p {
                    margin-top: 40px;
                    margin-bottom: 0;
                    color: #9ca2ad;
                }
            }
            .status {
                width: 20%;
                padding-top: 20px;
                text-align: center;
                border-top: 1px solid #d8dde6;
                border-right: 1px solid #d8dde6;
                p {
                    margin-top: 10px;
                    margin-bottom: 0;
                    color: #9ca2ad;
                }
            }
            .action {
                width: 20%;
                padding-top: 20px;
                text-align: center;
                border-top: 1px solid #d8dde6;
                button {
                    background: #f74845;
                    border-radius: 4px;
                    width: 80px;
                    height: 28px;
                    padding: 0;
                    font-size: 14px;
                    color: #FFF;
                    border: 0;
                }
                p {
                    margin: 5px 0;
                    color: #9ca2ad;
                    span {
                        cursor: pointer;
                        &:hover {
                            color: dodgerblue;
                        }
                    }
                }
                .wait {
                    color: #000;
                    font-size: 18px;
                }
            }
        }
    }
</style>
<style>
    .point {
        width: 8Px;
        height: 8Px;
        border-radius: 50%;
        background: rgb(247, 72, 69);
        margin: 5Px;
    }

    .points:hover {
        color: dodgerblue !important;
        cursor: pointer;
    }

    .addsp {
        right: 30px;
        top: 6px;
        position: absolute;
    }
</style>



// WEBPACK FOOTER //
// src/components/OrderList/Order.vue